<div class="ion-padding text-center flex-column flex-center">
    @if (headerIcon) {
        <div
            *ngIf="headerIcon"
            class="alert-modal--icon-wrapper flex-vertical-center margin-bottom"
            [style.background-color]="headerIconBackground">
            <lib-svg-icon
                [size]="headerIconSize"
                [iconName]="headerIcon"
                [color]="headerIconColor"
                [roundBorder]="true"
                borderColor="transparent"
                [backgroundColor]="headerIconBackgroundColor" />
        </div>
    }

    @if (headerText) {
        <h3 [style.color]="headerTextColor" class="ion-no-margin margin-bottom font-500">{{ headerText }}</h3>
    }

    @if (message) {
        <p class="margin-bottom text-dark-80">{{ message }}</p>
    }

    <div class="full-width">
        <ng-content></ng-content>
    </div>

    @if (confirmButtonLabel) {
        <div class="full-width margin-top">
            <lib-button (onClick)="confirm()" [expand]="true">
                {{ confirmButtonLabel }}
            </lib-button>
        </div>
    }

    @if (cancelButtonLabel) {
        <div class="full-width margin-top-small">
            <lib-button (onClick)="cancel()" [expand]="true" fill="outline" class="full-width">
                {{ cancelButtonLabel }}
            </lib-button>
        </div>
    }
</div>
